import { wechatArticleService, wechatCircleService} from './instance.js'
import {getSignHeader} from '@/utils/getSignHeader.js'

export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  ret = ret.slice(0, -1)
  return ret
}]

//获取资讯详情
export const getNewsContent = async (newsId, appCode) => {
  let params = {newsId, applicationCode: appCode}
  let headers = getSignHeader(params)
  return await wechatArticleService.get(`${appCode}/news/content`, {params, headers})
}

export const activeNewsReadCount = async (newsId, appCode) => {
  let params = {newsId, applicationCode: appCode}
  let headers = getSignHeader(params)
  return await wechatArticleService.get(`${appCode}/news/hitCount/application`, {
    params, headers
  })
}

//获取评论列表
export const getNewsCommentsList = async (newsId, token, appCode) =>{
  let params =  {
    newsId, token, pageSize: 9999, pageNo: 1, platformSelect: 1 //platformselect留言置顶开关1为开
  }
  let headers = getSignHeader(params)
  return await wechatCircleService.get(`/review/list/${appCode}`, {
    params, headers
  })
}

//获取资讯动态
export const getNewsDetail = async (newsId, token, appCode) => {
  let params = {newsId,token}
  let headers = getSignHeader(params)
  return await wechatCircleService.get(`/news/customer/news/detail/${appCode}`, {
    params, headers
  })
}

//评论文章
export const submitNewsComment = async (content, newsId, uid, appCode, columnCodes, serverId) =>{
  let params = {content, newsId, token: uid, platform: appCode, column: columnCodes, serverId}
  let headers = getSignHeader(params)
  const res =  await wechatCircleService.post(`/review/customer/reviews/${appCode}`, params, {transformRequest, headers})
  return res.data
}

//点赞文章
export const supportArticle = async (newsId, token, appCode, serverId) => {
  let params =  {
    newsId, token, serverId
  }
  let headers = getSignHeader(params)
  return await wechatCircleService.post(`/review/customer/support/news/${appCode}`, params, {transformRequest,headers})
}

//取消点赞文章
export const unSupportArticle = async (newsId, uid, appCode, serverId) => {
  let params =  {
    newsId, token: uid, serverId
  }
  let headers = getSignHeader(params)
  return await wechatCircleService.post(`/review/customer/unSupport/news/${appCode}`, params, {transformRequest,headers})
}

export const getNewsArticles = async (columnCodes, appCode) => {
  let params =  {
    columnCodes, appCode
  }
  let headers = getSignHeader(params)
  return await wechatArticleService.get(`${appCode}/news/listWithColumn`, {
    params, headers
  })
}

export const getArticleList = async(params) => {
  let headers = getSignHeader(params)
  return await wechatArticleService.get(`${params.appCode}/news/list`, { params, headers })
}

export const getSubjectColumnList = async(appCode, params) => {
  let headers = getSignHeader(params)
  const {data} =  await wechatArticleService.get(`${appCode}/column/subject`, { params, headers })
  return data.data
}

export const getSubject = async(appCode, params) => {
  let headers = getSignHeader(params)
  const {data} =  await wechatArticleService.get(`${appCode}/subject/detail`, { params, headers })
  return data.data
}